import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Alert } from 'assets/icons/Alert.svg';
import useToast from 'contexts/ToastProvider/useToast';

import { getAndRemoveSessionStorageValue, SessionStateKeys } from './useSessionState';

const useSessionLoggedOut = () => {
  const { t } = useTranslation();
  const { pushToast } = useToast();

  useEffect(() => {
    const isSessionLoggedOut = getAndRemoveSessionStorageValue<boolean>(SessionStateKeys.IS_SESSION_LOGGED_OUT);
    if (!isSessionLoggedOut) return;

    pushToast({
      title: t('session_logged_out'),
      description: t('session_logged_out_description'),
      variant: 'info',
      autoDismiss: false,
      icon: Alert,
    });
  }, [pushToast, t]);
};

export default useSessionLoggedOut;
